export default {"src":"/_next/static/media/green_check_mark.a9c7775f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};